import React from "react"

import classNames from "classnames"

import { ContentTag, Obj } from "scrivito"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { useProductPageContext } from "../context/ProductPageContext"

interface ProductPageSubTitleProps
  extends React.HTMLAttributes<HTMLDivElement> {}

function SubTitleContent({
  children,
  value,
  isLoading,
  className,
  innerRef,
  ...props
}: {
  children: React.ReactNode
  value: string | undefined
  isLoading: boolean | undefined
  innerRef: React.Ref<HTMLDivElement>
} & React.HTMLAttributes<HTMLDivElement>) {
  if (!value && !isLoading) return null

  if (isLoading && !value)
    return (
      <div
        {...props}
        ref={innerRef}
        className={classNames("product-page__subtitle", className)}
      >
        <Skeleton />
      </div>
    )

  return (
    <div
      {...props}
      ref={innerRef}
      className={classNames("product-page__subtitle", className)}
    >
      {children ?? value}
    </div>
  )
}

export const ProductPageSubTitle = React.memo(
  React.forwardRef<HTMLDivElement, ProductPageSubTitleProps>(
    ({ className, children, ...props }, ref) => {
      const { productData, productObj, productBaseVariantObj } =
        useProductPageContext()

      const isLoading = productData.productInformation?.isLoading
      const scrivitoObj = productBaseVariantObj || productObj

      if (scrivitoObj) {
        return (
          <ContentTag
            {...props}
            ref={ref}
            tag="div"
            content={scrivitoObj as Obj}
            attribute="titleShort"
            className={classNames("product-page__subtitle", className)}
          />
        )
      }

      const title = productData.productInformation?.data?.shortTitle

      return (
        <SubTitleContent
          {...props}
          innerRef={ref}
          className={className}
          value={title}
          isLoading={isLoading}
        >
          {children}
        </SubTitleContent>
      )
    }
  )
)
